import React from "react";

import RoleAccordion from "./RoleExplainerAccordion";

export interface RoleExplanations {
	role_summary: {
		en: string;
		sw: string;
	};
	what_you_will_do: {
		en: string[];
		sw: string[];
	};
	what_you_need: {
		en: string[];
		sw: string[];
	};
	how_to_apply: {
		instructions: {
			en: string;
			sw: string;
		};
		include: {
			en: string[];
			sw: string[];
		};
	};
	cta_fit_check: {
		en: string;
		sw: string;
	};
}

function RoleExplainer({ roleExplanations }: { roleExplanations?: RoleExplanations }) {
	const enContent =
		roleExplanations && Object.keys(roleExplanations).length > 0 ? (
			<>
				{/* Summary */}
				<h3 className="font-semibold text-sm">Summary</h3>
				<p className="mt-1 text-sm">{roleExplanations.role_summary.en || "No summary provided."}</p>

				{/* What You’ll Do */}
				<h3 className="font-semibold text-sm mt-3">What You’ll Do</h3>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations.what_you_will_do.en || []).map((role, index) => (
						<li key={index}>{role || "—"}</li>
					))}
				</ul>

				{/* What You Need */}
				<h3 className="font-semibold text-sm mt-3">What You Need</h3>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations.what_you_need.en || []).map((item, index) => (
						<li key={index}>{item || "—"}</li>
					))}
				</ul>

				<hr className="mb-2 mt-2" />

				{/* How to Apply */}
				<h3 className="font-semibold text-sm">How to Apply</h3>
				<p className="mt-1 text-sm">
					{roleExplanations?.how_to_apply?.instructions.en || "No application instructions provided."}
				</p>

				<h3 className="font-semibold text-sm mt-3">Include:</h3>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations?.how_to_apply?.include.en || []).map((includeItem, index) => (
						<li key={index}>{includeItem || "—"}</li>
					))}
				</ul>

				<hr className="mb-2 mt-2" />

				<p className="text-sm">
					<a href="#">Fit check me</a> and We will tell you how well you match the role.
				</p>
			</>
		) : (
			<p className="mt-1 text-sm">No role explainer for this job.</p>
		);

	const swContent =
		roleExplanations && Object.keys(roleExplanations).length > 0 ? (
			<>
				{/* Summary */}
				<h3 className="font-semibold text-sm">Muhtasari</h3>
				<p className="mt-1 text-sm">{roleExplanations.role_summary.sw || "Hakuna muhtasari uliotolewa."}</p>

				{/* What You’ll Do */}
				<h3 className="font-semibold text-sm mt-3">Majukumu yako</h3>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations.what_you_will_do.sw || []).map((role, index) => (
						<li key={index}>{role || "—"}</li>
					))}
				</ul>

				{/* What You Need */}
				<h3 className="font-semibold text-sm mt-3">Unachohitaji</h3>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations.what_you_need.sw || []).map((item, index) => (
						<li key={index}>{item || "—"}</li>
					))}
				</ul>

				<hr className="mb-2 mt-2" />

				{/* How to Apply */}
				<h3 className="font-semibold text-sm">Namna ya Kutuma Maombi</h3>
				<p className="mt-1 text-sm">
					{roleExplanations?.how_to_apply?.instructions.sw || "Hakuna maelekezo ya kuomba yaliyotolewa."}
				</p>

				<h3 className="font-semibold text-sm mt-3">Jumuisha:</h3>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations?.how_to_apply?.include.sw || []).map((includeItem, index) => (
						<li key={index}>{includeItem || "—"}</li>
					))}
				</ul>

				<hr className="mb-2 mt-2" />

				<p className="text-sm">
					<a href="#">Tathmini ulinganifu wako</a> nasi tutakuambia jinsi ufaavyo kwa kazi hii.
				</p>
			</>
		) : (
			<p className="mt-1 text-sm">Hakuna maelezo ya majukumu ya kazi hii.</p>
		);

	return (
		<RoleAccordion
			title="Role Explainer"
			content={{
				en: enContent,
				sw: swContent,
			}}
		/>
	);
}

export default RoleExplainer;
